import React from 'react';
import SafeIcon from '../common/SafeIcon';

const MyApplications = () => {
  const APPS = [
    { title: 'Operations Manager', company: 'RMGhana', status: 'Interviewing', date: '2 days ago', progress: 65 },
    { title: 'Logistics Supervisor', company: 'Tullow Oil (External)', status: 'Applied', date: '1 week ago', progress: 20 },
  ];

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-800">My Job Applications</h1>
      
      <div className="space-y-4">
        {APPS.map(app => (
          <div key={app.title} className="card p-6 border border-gray-100">
            <div className="flex justify-between items-center mb-4">
              <div>
                <h3 className="font-bold text-lg text-gray-800">{app.title}</h3>
                <p className="text-sm text-gray-500">{app.company} · {app.date}</p>
              </div>
              <span className="px-3 py-1 bg-blue-50 text-[#11469A] text-[11px] font-bold uppercase tracking-wider rounded-lg">{app.status}</span>
            </div>
            <div className="space-y-2">
              <div className="flex justify-between text-xs font-bold text-gray-400 uppercase tracking-widest">
                <span>Application Progress</span>
                <span>{app.progress}%</span>
              </div>
              <div className="w-full bg-gray-100 h-2 rounded-full overflow-hidden">
                <div className="bg-[#11469A] h-full transition-all duration-1000" style={{width: `${app.progress}%`}}></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyApplications;